import { secureApiCall, SubscriptionType } from './secureApiClient'

interface ApiCallerProps {
  url: string
  method: 'GET' | 'DELETE' | 'PATCH' | 'POST' | 'PUT'
  data?: any
  headers?: HeadersInit
  signal?: AbortSignal
}

/**
 * DEPRECATED: This function still exists for backward compatibility
 * but now uses the secure proxy instead of embedding subscription keys.
 *
 * SECURITY: All subscription keys are now handled server-side.
 * No keys are embedded in the client bundle.
 *
 * @deprecated Use secureApi from secureApiClient.ts directly for new code
 */
export const apiCaller = async ({ url, method, data, headers, signal }: ApiCallerProps): Promise<any> => {
  // Determine which subscription type to use based on URL
  let subscriptionType: SubscriptionType

  if (url.includes('dboperator')) {
    subscriptionType = 'dbo'
  }
   else if (url.includes('resource-manager')) {
    subscriptionType = 'all'
  } else if (url.includes('get-cloud-info') || url.includes('csc-apim.azure-api.net'))  {
    // Cloud info functions use the all-functions subscription key
    subscriptionType = 'all'
  } else {
    // For non-APIM URLs, make direct call (no subscription key needed)
    const options: RequestInit = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...headers
      },
      signal
    }

    if (data && (method === 'POST' || method === 'PATCH' || method === 'PUT')) {
      // Stringify if it's an object, otherwise use as-is (for backward compatibility with already-stringified data)
      options.body = typeof data === 'string' ? data : JSON.stringify(data)
    }

    const response = await fetch(url, options)
    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`API error: ${response.status} ${response.statusText} - ${errorText}`)
    }
    return response
  }

  // Use secure proxy for APIM calls
  const result = await secureApiCall({
    targetUrl: url,
    method,
    subscriptionType,
    body: typeof data === 'string' ? JSON.parse(data) : data,
    customHeaders: headers as Record<string, string> | undefined,
    signal
  })

  if (result.error) {
    console.error('❌ [apiCaller] API error:', {
      url,
      method,
      subscriptionType,
      status: result.status,
      error: result.error
    })
    throw new Error(`API error: ${result.status} - ${result.error}`)
  }

  // Return a Response-like object for backward compatibility
  return {
    ok: true,
    status: result.status,
    json: async () => result.data,
    text: async () => JSON.stringify(result.data)
  }
}
